import { Button, Input, Modal, ModalProps, Typography } from 'antd'
import copy from 'copy-to-clipboard'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'

interface InvitationLinkProps extends ModalProps {
  link: string
}

function InvitationLink(props: InvitationLinkProps) {
  const { link, ...modalProps } = props
  const [isVisible, setIsVisible] = useState(true)

  if (!link) {
    return null
  }

  return (
    (<Modal
      {...modalProps}
      open={isVisible}
      onOk={(e) => {
        setIsVisible(false)
        modalProps.onOk?.(e)
      }}
      onCancel={(e) => {
        setIsVisible(false)
        modalProps.onCancel?.(e)
      }}
      footer={null}
    >
      <Typography.Title level={4}>Public links, quick invitations</Typography.Title>
      <Typography.Text type='secondary'>
        Send the following public invitation link to people who need to be invited
      </Typography.Text>
      <Input.Group compact size='large' className={'my-1'}>
        <Input disabled={true} style={{ width: 'calc(100% - 80px)' }} defaultValue={link} />
        <Button
          type='primary'
          size='large'
          onClick={() => {
            copy(link)
          }}
        >
          Copy
        </Button>
      </Input.Group>
      <Typography.Text type='secondary'>The link is valid for 14 days</Typography.Text>
    </Modal>)
  );
}

InvitationLink.show = (props: InvitationLinkProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const close = () => div.remove()

  ReactDOM.render(
    <InvitationLink
      {...props}
      afterClose={() => {
        props.afterClose?.()
        close()
      }}
    />,
    div
  )
}

export default InvitationLink
